mutationResult